
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { postAddVersion, updateVersion, existsVersion, existsVersionUrl } from '@/api/version';
import { eUpdateType, eUpdateVersion, iVersion } from '@/interface/version';
import UpdateContent from './update-content.vue';
import { UserModule } from '@/store/modules/user';
import { toast } from '@/utils/common';

@Component({
  components: { UpdateContent },
})
export default class EditVersion extends Vue {
  @Prop() visible!: Boolean;
  @Prop() flag?: Number;
  @Prop() model!: iVersion;
  @Prop() exitTitle!: string;
  andriod: eUpdateVersion = eUpdateVersion.ANDRIOD;
  seletUpdate: eUpdateType = eUpdateType.SELECTUPDATE;
  select: eUpdateType = eUpdateType.SELECT;
  newMode: any = [];
  isFocusTrue: boolean = false;
  errorMsg: string = '';
  reg = /^[0-9]+\.[0-9]+\.[0-9]+$/;
  rules = {
    version: [{ required: true, validator: this.validateVersion, trigger: 'blur' }],
    change_log: [{ require: true, trigger: 'blur', validator: this.validateChangeLog }],
  };
  validateChangeLog(rule: any, value: any, callback: any) {
    const obj = this.newMode.change_log;
    let len = 0;
    for (let i = 0; i < obj.length; i++) {
      const value = obj[i].trim();
      len += value.length;

      if (value == '') {
        return callback(new Error('请输入内容：' + (i + 1)));
      } else if (len > 150) {
        return callback(new Error('更新内容不能大于150字'));
      } else {
        if (i == obj.length - 1) {
          return callback();
        }
      }
    }
  }
  validateVersion(rule: any, value: any, callback: any) {
    // const reg = /^\d.\d.\d/;

    this.errorMsg = '';
    if (this.reg.test(value)) {
      return callback();
    } else {
      this.errorMsg = '版本号请输入：列(1.2.3)';
      return callback(new Error('版本号请输入：列(1.2.3)'));
    }
  }
  AddText() {
    this.newMode.change_log.push('');
  }
  deleteText(index: number) {
    this.newMode.change_log.splice(index, 1);
  }
  changeValue(index: number, value: string) {
    this.newMode.change_log[index] = value;
  }
  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.isFocusTrue = false;
        this.saveVersion();
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  @Emit()
  close() {}
  /* 检查是否存在 */
  // async checkExists() {
  //   const { version, scope, id } = this.newMode;
  //   if (await this.existsVersionUrl()) {
  //     //验证是否在数据库中存在
  //     const res = await existsVersion({ version, scope, id });
  //     if (res.code != 0) {
  //       return;
  //     }
  //   }
  //}
  // async existsVersionUrl() {
  //   //验证版本是否在服务器上存在
  //   try {
  //     this.errorMsg = '';
  //     if (!this.reg.test(this.newMode.version)) {
  //       this.errorMsg = '版本号请输入：列(1.2.3)';
  //       return;
  //     }
  //     //云电脑 //小悟云
  //     const appID = UserModule.activeBrand;
  //     let version = '';
  //     if (appID == 'xiaowuyun') {
  //       version = `superxiaowu/android/superxiaowu_${this.newMode.version}.apk`;
  //     } else {
  //       version = `cloudpc/android/cloudpc_${this.newMode.version}.apk`;
  //     }
  //     const res = await existsVersionUrl(version);
  //     return true;
  //     //验证是否在数据库中存在
  //   } catch {
  //     (this as any).$message.closeAll();
  //     // toast('该版本不存在，请重新输入', 'error');
  //     this.errorMsg = '该版本不存在，请重新输入';

  //     console.log(this.errorMsg);

  //     return false;
  //   }
  // }
  async saveVersion() {
    // const isTrue = await this.existsVersionUrl();
    // if (isTrue == false) {
    //   return;
    // }
    this.$msgbox({
      title: '提示',
      message: this.newMode.id <= 0 ? '确定添加?' : '确定修改?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          let res;
          if (this.newMode.id > 0) {
            res = await updateVersion(this.newMode);
          } else {
            res = await postAddVersion(this.newMode);
          }
          if (res.code == 0) {
            this.$emit('close');
            toast('操作成功!');
          } else {
            toast(res.msg, 'error');
          }
          instance.confirmButtonLoading = false;

          done();
        } else if (action === 'cancel') {
          instance.confirmButtonLoading = false;
          done();
        }
      },
    })
      .then(() => {
        // done();
      })
      .catch((err: any) => {
        console.log(err);
      });
  }
  mounted() {
    this.newMode = this.model;
    if (this.newMode.id <= 0) {
      this.newMode.change_log = ['', ''];
    }
  }
}
